import { render, staticRenderFns } from "./judgmentItemForm.vue?vue&type=template&id=c7c4494c&scoped=true"
import script from "./judgmentItemForm.vue?vue&type=script&lang=js"
export * from "./judgmentItemForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c4494c",
  null
  
)

export default component.exports